import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SpinnerService } from '../../spinner.service';
import { RelatoriosService } from '../../services/relatorios.service';
import {environment} from '../../../environments/environment';

declare let gtag: (property: string, value: any, configs: any) => {};

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {

    isLoading: boolean = false;

    constructor(
        public router: Router,
        private spinnerService: SpinnerService,
        private relatoriosService: RelatoriosService
    ) {
        this.relatoriosService.carregar();

        this.spinnerService.status.share().subscribe((status: boolean) => {
            // setTimeout avoids ExpressionChangedAfterItHasBeenCheckedError in Angular 6
            setTimeout(() => { this.isLoading = status; }, 0);
        });

        this.router.events.subscribe(event => {
          if (event instanceof NavigationEnd) {
            gtag('config', environment.googleAnalyticsId, {
              page_path: event.urlAfterRedirects
            });
          }
        });
      }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }
}
